module.exports = __webpack_public_path__ + "static/media/Ake.31e05446.PNG";